import { TaskStatus } from '../store/slices/taskSlice';
import { isDisplayableImage } from './fileUtils';
import { buildLegacyFileUrl } from '../services/fileUrlService';

const EMPTY_HTML = new Set(['', '<p><br></p>', '<p></p>', '<p><br/></p>']);

const escapeHtml = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const stripToText = (html) => String(html || '')
  .replace(/<[^>]+>/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const editorImageSrc = (fileKey) => {
  if (!fileKey) return '';
  if (/^(https?:\/\/|data:|blob:)/i.test(fileKey)) return fileKey;
  return buildLegacyFileUrl(fileKey) || fileKey;
};

const imageEmbedHtml = (attachments) => {
  const images = (attachments || []).filter(isDisplayableImage);
  if (!images.length) return '';
  return images.map((img) => {
    const src = editorImageSrc(img?.fileUrl || img?.url || img?.fileKey || '');
    if (!src) return '';
    return `<p><img src="${escapeHtml(src)}" alt=""></p>`;
  }).filter(Boolean).join('') || '';
};

export const isEmptyMessageHtml = (content) => EMPTY_HTML.has(String(content || '').trim());

export const isMessageMappable = (content) => !isEmptyMessageHtml(content);

export const messageHasTaskContent = (message) => {
  if (!message) return false;
  if (isMessageMappable(message.content)) return true;
  const attachments = Array.isArray(message.attachments) ? message.attachments : [];
  return attachments.some((item) => item && (item.fileUrl || item.url || item.fileName));
};

export const descriptionHtmlFromMessage = (message) => {
  const attachments = Array.isArray(message?.attachments) ? message.attachments : [];
  const images = attachments.filter(isDisplayableImage);
  const text = stripToText(message?.content);
  const textIsFileName = attachments.some((item) => {
    const name = String(item?.fileName || '').trim();
    return name && name === text;
  });

  if (images.length && (!text || textIsFileName || String(message?.type || '').toUpperCase() === 'IMAGE')) {
    return imageEmbedHtml(attachments) || '<p>sent image</p>';
  }
  if (isMessageMappable(message?.content) && !textIsFileName) return message.content;
  if (attachments.length) {
    const names = attachments.map((item) => escapeHtml(item.fileName || 'file')).filter(Boolean).join(', ');
    return `<p>sent a file${names ? `: ${names}` : ''}</p>`;
  }
  return '';
};

export const resolveParentTaskIdForWorkflow = async (dispatch, fetchTasks, createTask, workflowTarget) => {
  const workflowMessageId = workflowTarget.messageId;
  const existing = await dispatch(fetchTasks({ messageId: workflowMessageId })).unwrap();
  const list = Array.isArray(existing) ? existing : [];
  const parent = list.find((t) => (
    (!t.mapTaskId || !String(t.mapTaskId).trim())
    && !(t.title || '').trim()
  ));
  if (parent?.id) return parent.id;

  const description = workflowTarget.contentHtml?.trim()
    || workflowTarget.content?.trim()
    || '<p>Workflow item</p>';

  const created = await dispatch(createTask({
    title: '',
    description,
    messageId: workflowMessageId,
    status: TaskStatus.PENDING,
  })).unwrap();

  return created.id;
};
